import axios from '../http'
import global from '@/constants/Global.constants'

export default {
  getProvince(params) { // 获取省级数据
    return axios.post(global.MSI_BASE + '/info/pca/findProvince', params)
  },
  getCity(params) { // 获取市级数据
    return axios.post(global.MSI_BASE + '/info/pca/findCity', params)
  },
  getArea(params) { // 获取区级数据
    return axios.post(global.MSI_BASE + '/info/pca/findArea', params)
  },
  getAddressList(params) { // 获取地址列表
    return axios.post(global.CMC_DEARADDRESS + '/findDearAddress', params)
  },
  addAddress(params) { // 新增地址
    return axios.post(global.CMC_DEARADDRESS + '/insertDearAddress', params)
  },
  editAddress(params) { // 修改地址
    return axios.post(global.CMC_DEARADDRESS + '/updateAddress', params)
  },
  setDefaultAddress(params) { // 设置默认地址
    return axios.post(global.CMC_DEARADDRESS + '/updateDefaultAddress', params)
  },
  deleteAddress(params) { // 删除地址
    return axios.post(global.CMC_DEARADDRESS + '/deleteDearAddress', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/member/address.js